// SEC-027 (recommendation 4): nothing today notices that the stored access
// token has expired before using it — a call just gets a 401 that each
// component handles (or doesn't) on its own. This decodes the token's `exp`
// claim client-side, which is enough to catch "obviously expired" before a
// request goes out; the server's own signature check is and stays the real
// control, this is only ever used to decide whether to bother asking.
export function decodeJwtPayload(token) {
  try {
    const payload = token.split(".")[1];
    const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
    const json = decodeURIComponent(
      atob(base64)
        .split("")
        .map((char) => "%" + char.charCodeAt(0).toString(16).padStart(2, "0"))
        .join("")
    );
    return JSON.parse(json);
  } catch (_) {
    return null;
  }
}

// A token with no readable `exp` claim (malformed, or not actually a JWT)
// is treated as expired rather than as "can't tell" — the point of this
// check is to fail toward re-authentication, not to wave through whatever
// it can't parse.
export function isTokenExpired(token) {
  const payload = decodeJwtPayload(token);
  if (!payload?.exp) return true;
  return Date.now() >= payload.exp * 1000;
}
